import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { Navigation, Pagination } from "swiper";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { lazy, Suspense, useEffect, useState } from "react";
import VideoService from "services/video/VideoService";
import VideoHeroSkeleton from "components/skeleton/VideoHeroSkeleton";
import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";

const HeroCard = lazy(() => import("pages/videoPage/home/shared/HeroCard"));

function HeroCarousel() {
  const [sliderData, setSliderData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    setIsLoading(true);
    VideoService.getSliderDetails().then((res) => {
      setIsLoading(false);
      const video: any[] = res.movies;
      const tv: any[] = res.tv_series;
      const all: any[] = video.concat(tv);
      setSliderData(all);
    });
  }, []);
  return (
    <>
      {!isLoading && (
        <ErrorBoundary>
          <Suspense fallback={<VideoHeroSkeleton />}>
            <Swiper
              navigation={false}
              modules={[Navigation, Autoplay, Pagination]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
            >
              {sliderData.map((d: any, i: number) => (
                <SwiperSlide className="mb-15" key={i}>
                  <HeroCard data={d} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Suspense>
        </ErrorBoundary>
      )}
      {isLoading && <VideoHeroSkeleton />}
    </>
  );
}

export default HeroCarousel;
